// import ArticleInsideBTGNewsletter from "@routes/Article/components/ArticleNewsletter/ArticleInsideBTGNewsletter";
import AseanInsightsEntry from "@routes/Article/components/SixthParagraphWidget/AseanInsightsEntry";
import Budget2026Banner from "@routes/Article/components/SixthParagraphWidget/Budget2026Banner";
import { isBudget2026Tag } from "@routes/Article/components/SixthParagraphWidget/utils/helpers";
import { FeedTag } from "@routes/Keyword/utils/types";
import { getEnvironment } from "@util/constant";
import { getEnvironmentDomain } from "@util/helpers";

type SixthParagraphWidgetProps = {
  /** This is the tags array of the component. */
  tags: FeedTag[];
};

/** Component to decide what to display after the sixth paragraph. */
const SixthParagraphWidget = ({
  tags,
}: SixthParagraphWidgetProps): React.ReactElement => {
  const domain = getEnvironmentDomain(getEnvironment());
  const budget2026URLPath = `${domain}/keywords/singapore-budget-2026`;

  if (isBudget2026Tag(tags, budget2026URLPath)) {
    return <Budget2026Banner />;
  }

  // return <ArticleInsideBTGNewsletter className="no-print mb-6 lg:-mx-8" />;
  return <AseanInsightsEntry className="no-print mb-6 lg:-mx-8" />;
};

export default SixthParagraphWidget;
